const localBlogTranslations = {
  "67aa57375fcb462971544ca7": {
    en: {
      title: "A day in the life of a QA Engineer",
      summary: "We explore a typical workday for a QA engineer and the key responsibilities in the software industry.",
    },
    de: {
      title: "Ein Tag im Leben eines QA Engineers",
      summary: "Wir erkunden einen typischen Arbeitstag eines QA Engineers und die wichtigsten Aufgaben in der Softwarebranche.",
    },
  },
  "67aa57375fcb462971544ca8": {
    en: {
      title: "What should I do to keep growing as a QA professional?",
      summary: "Key tips to improve your skills and advance your QA career in a constantly evolving world.",
    },
    de: {
      title: "Was sollte ich tun, um als QA-Profi weiter zu wachsen?",
      summary: "Wichtige Tipps, um deine Fahigkeiten zu verbessern und deine QA-Karriere in einer sich standig wandelnden Welt voranzubringen.",
    },
  },
  "67aa57375fcb462971544ca9": {
    en: {
      title: "Recommendations for beginners",
      summary: "If you are getting started in the QA world, here are some essential recommendations to begin successfully.",
    },
    de: {
      title: "Empfehlungen fur Einsteiger",
      summary: "Wenn du in die QA-Welt einsteigst, findest du hier einige wichtige Empfehlungen fur einen erfolgreichen Start.",
    },
  },
  "67b3b8a4a06603b9f2e43269": {
    en: {
      title: "How can you increase your productivity?",
      summary: "Discover effective strategies to optimize your time and improve your performance in QA and programming.",
    },
    de: {
      title: "Wie kannst du deine Produktivitat steigern?",
      summary: "Entdecke wirksame Strategien, um deine Zeit zu optimieren und deine Leistung in QA und Programmierung zu verbessern.",
    },
  },
  "67b3b8a4a06603b9f2e4326a": {
    en: {
      title: "Top 10 testing tools",
      summary: "Explore essential tools for automation and manual testing in the Quality Assurance world.",
    },
    de: {
      title: "Top 10 Testing-Tools",
      summary: "Entdecke wichtige Tools fur Automatisierung und manuelles Testing in der Welt der Quality Assurance.",
    },
  },
  "67b3b8a4a06603b9f2e4326b": {
    en: {
      title: "How to create your channel",
      summary: "A step-by-step guide to launch your content channel and share your knowledge with the world.",
    },
    de: {
      title: "Wie du deinen Kanal erstellst",
      summary: "Eine Schritt-fur-Schritt-Anleitung, um deinen Content-Kanal zu starten und dein Wissen mit der Welt zu teilen.",
    },
  },
};

export function getLocalizedBlog(blog, language) {
  if (!blog || language === "es") return blog;

  const id = blog._id?.toString?.() || blog._id;
  const dbTranslation = blog.translations?.[language] || {};
  const localTranslation = localBlogTranslations[id]?.[language] || {};
  const translation = { ...localTranslation, ...dbTranslation };

  return {
    ...blog,
    title: translation.title || blog.title,
    summary: translation.summary || blog.summary,
    content: translation.content || blog.content,
  };
}
